// Hides payment-setup entry points (route, dashboard banner/menu, payout CTAs)
// when set to "false". Default on: creators add a US bank account in-app.
export const PAYMENT_SETUP_ENABLED =
    process.env.REACT_APP_PAYMENT_SETUP_ENABLED !== 'false';
